(() => {
  "use strict";

  const configNode = document.querySelector("#rdVoteM10Config");
  if (!configNode) return;

  let config;
  try {
    config = JSON.parse(configNode.textContent);
  } catch (error) {
    console.error("RUDEDOG M10 vote configuration is invalid", error);
    return;
  }

  const ARTWORKS = Array.isArray(config.artworks) ? config.artworks : [];
  const audience = config.audience === "dealer" ? "dealer" : "customer";
  const endpoint = String(config.endpoint || "");
  const campaign = String(config.campaign || "m10-model-vote-2026");
  const qaMode = new URLSearchParams(window.location.search).get("_rd_vote_qa") === "1";
  const STORAGE_KEY = `rudedog-artwork-vote-${campaign}-${audience}-v2`;

  const COPY = {
    customer: {
      badge: "ลูกค้า · นิรนาม",
      perspective: "มุมมองลูกค้า",
      question: "ถ้าวางขายจริง คุณอยากซื้อเสื้อลายนี้แค่ไหน?",
      anchors: ["ชอบน้อยสุด", "", "ชอบสุด"],
    },
    dealer: {
      badge: "ดีลเลอร์ · นิรนาม",
      perspective: "มุมมองดีลเลอร์",
      question: "ลายนี้มีโอกาสขายในร้านคุณแค่ไหน?",
      anchors: ["น่าจะขายยาก", "", "น่าจะขายดี"],
    },
  };

  const state = {
    currentIndex: 0,
    ratings: {},
    finalists: [],
    orderSlugs: createRandomOrder(),
    activePlayer: 0,
    transitionTimer: null,
    videoTransitionTimer: null,
    isTransitioning: false,
    sessionId: createSessionId(),
    startedAt: 0,
    submitted: false,
    reward: null,
    lastPayload: null,
    viewed: new Set(),
  };

  const $ = (selector) => document.querySelector(selector);
  const introScreen = $("#introScreen");
  const voteScreen = $("#voteScreen");
  const finalistScreen = $("#finalistScreen");
  const completeScreen = $("#completeScreen");
  const startButton = $("#startButton");
  const startLabel = $("#startLabel");
  const exitButton = $("#exitButton");
  const previousButton = $("#previousButton");
  const audienceBadge = $("#audienceBadge");
  const votePerspective = $("#votePerspective");
  const ratingQuestion = $("#ratingQuestion");
  const lowAnchor = $("#lowAnchor");
  const middleAnchor = $("#middleAnchor");
  const highAnchor = $("#highAnchor");
  const currentNumber = $("#currentNumber");
  const totalNumber = $("#totalNumber");
  const progressValue = $("#progressValue");
  const artworkTitle = $("#artworkTitle");
  const artworkTags = $("#artworkTags");
  const videoLoader = $("#videoLoader");
  const ratingButtons = [...document.querySelectorAll("[data-rating]")];
  const players = [$("#videoA"), $("#videoB")];
  const finalistGrid = $("#finalistGrid");
  const finalistStatus = $("#finalistStatus");
  const backToRatingsButton = $("#backToRatingsButton");
  const submitButton = $("#submitButton");
  const rewardState = $("#rewardState");
  const rewardChoices = $("#rewardChoices");
  const rewardCodeRow = $("#rewardCodeRow");
  const rewardCode = $("#rewardCode");
  const rewardExpiry = $("#rewardExpiry");
  const retryRewardButton = $("#retryRewardButton");
  const toast = $("#toast");

  totalNumber.textContent = String(ARTWORKS.length);

  function createSessionId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") return window.crypto.randomUUID();
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
  }

  function randomUnit() {
    if (window.crypto && typeof window.crypto.getRandomValues === "function") {
      const buffer = new Uint32Array(1);
      window.crypto.getRandomValues(buffer);
      return buffer[0] / 4294967296;
    }
    return Math.random();
  }

  function createRandomOrder() {
    const slugs = ARTWORKS.map((item) => item.slug);
    for (let index = slugs.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(randomUnit() * (index + 1));
      [slugs[index], slugs[swapIndex]] = [slugs[swapIndex], slugs[index]];
    }
    return slugs;
  }

  function orderedArtworks() {
    const bySlug = new Map(ARTWORKS.map((item) => [item.slug, item]));
    const ordered = state.orderSlugs.map((slug) => bySlug.get(slug)).filter(Boolean);
    return ordered.length === ARTWORKS.length ? ordered : ARTWORKS;
  }

  function track(step, details = {}) {
    const payload = {
      event: "rd_vote_event",
      rd_vote_step: step,
      rd_vote_campaign: campaign,
      rd_vote_audience: audience,
      ...details,
    };
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent("rudedog:vote", { detail: payload }));
    } catch (error) {
      // Analytics must never interrupt voting.
    }
  }

  function persistState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        currentIndex: state.currentIndex,
        ratings: state.ratings,
        finalists: state.finalists,
        orderSlugs: state.orderSlugs,
        sessionId: state.sessionId,
        startedAt: state.startedAt,
        submitted: state.submitted,
        reward: state.reward,
      }));
    } catch (error) {
      // Voting remains usable when storage is blocked by an in-app browser.
    }
  }

  function restoreState() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!saved || typeof saved !== "object") return;
      const validSlugs = new Set(ARTWORKS.map((item) => item.slug));
      if (Array.isArray(saved.orderSlugs) && saved.orderSlugs.length === ARTWORKS.length && saved.orderSlugs.every((slug) => validSlugs.has(slug))) {
        state.orderSlugs = [...saved.orderSlugs];
      }
      if (Number.isInteger(saved.currentIndex)) state.currentIndex = Math.max(0, Math.min(saved.currentIndex, ARTWORKS.length - 1));
      if (saved.ratings && typeof saved.ratings === "object") {
        state.ratings = Object.fromEntries(Object.entries(saved.ratings).filter(([slug, score]) => validSlugs.has(slug) && Number(score) >= 1 && Number(score) <= 5));
      }
      if (Array.isArray(saved.finalists)) state.finalists = saved.finalists.filter((slug) => validSlugs.has(slug)).slice(0, 4);
      if (typeof saved.sessionId === "string" && saved.sessionId.length >= 16) state.sessionId = saved.sessionId;
      if (Number.isFinite(saved.startedAt)) state.startedAt = saved.startedAt;
      state.submitted = saved.submitted === true;
      if (saved.reward && typeof saved.reward === "object") state.reward = saved.reward;
      if (state.submitted && state.reward) startLabel.textContent = "ดูสิทธิ์ของฉันอีกครั้ง";
      else if (Object.keys(state.ratings).length > 0) startLabel.textContent = "ทำแบบโหวตต่อ";
    } catch (error) {
      try { localStorage.removeItem(STORAGE_KEY); } catch (storageError) {}
    }
  }

  function showToast(message, duration = 1800) {
    toast.textContent = message;
    toast.classList.add("is-visible");
    window.setTimeout(() => toast.classList.remove("is-visible"), duration);
  }

  function setScreen(screen) {
    [introScreen, voteScreen, finalistScreen, completeScreen].forEach((item) => item.classList.toggle("is-hidden", item !== screen));
    window.scrollTo(0, 0);
  }

  function updateAudienceCopy() {
    const copy = COPY[audience];
    audienceBadge.textContent = copy.badge;
    votePerspective.textContent = copy.perspective;
    ratingQuestion.textContent = copy.question;
    [lowAnchor.textContent, middleAnchor.textContent, highAnchor.textContent] = copy.anchors;
  }

  function playPlayer(player) {
    player.muted = true;
    const attempt = player.play();
    if (attempt && typeof attempt.catch === "function") attempt.catch(() => videoLoader.classList.add("is-ready"));
  }

  function loadPlayer(player, artwork, shouldPlay = false) {
    if (!artwork) {
      player.removeAttribute("src");
      player.removeAttribute("poster");
      player.load();
      return;
    }
    player.poster = artwork.poster;
    if (player.dataset.slug !== artwork.slug) {
      player.src = artwork.video;
      player.dataset.slug = artwork.slug;
      player.load();
    }
    player.playsInline = true;
    player.setAttribute("playsinline", "");
    player.setAttribute("webkit-playsinline", "");
    player.muted = true;
    if (shouldPlay) playPlayer(player);
  }

  function preparePlayers() {
    const artworks = orderedArtworks();
    const currentPlayer = players[state.activePlayer];
    const standbyPlayer = players[1 - state.activePlayer];
    currentPlayer.className = "artwork-video is-active";
    standbyPlayer.className = "artwork-video";
    loadPlayer(currentPlayer, artworks[state.currentIndex], true);
    loadPlayer(standbyPlayer, artworks[state.currentIndex + 1]);
  }

  function renderCurrent() {
    const artworks = orderedArtworks();
    const artwork = artworks[state.currentIndex];
    const savedRating = Number(state.ratings[artwork.slug]);
    currentNumber.textContent = String(state.currentIndex + 1).padStart(2, "0");
    progressValue.style.width = `${((state.currentIndex + 1) / artworks.length) * 100}%`;
    artworkTitle.textContent = artwork.title;
    artworkTags.textContent = artwork.tags;
    previousButton.disabled = state.currentIndex === 0;
    ratingButtons.forEach((button) => {
      const selected = Number(button.dataset.rating) === savedRating;
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-checked", String(selected));
    });
    if (!state.viewed.has(artwork.slug)) {
      state.viewed.add(artwork.slug);
      track("artwork_view", { rd_vote_artwork: artwork.slug, rd_vote_position: state.currentIndex + 1 });
    }
    updateAudienceCopy();
    persistState();
  }

  function transitionToIndex(nextIndex) {
    const artworks = orderedArtworks();
    if (state.isTransitioning || nextIndex < 0 || nextIndex >= artworks.length || nextIndex === state.currentIndex) return;
    state.isTransitioning = true;
    const oldPlayer = players[state.activePlayer];
    const nextPlayer = players[1 - state.activePlayer];
    const direction = nextIndex > state.currentIndex ? "forward" : "backward";
    const enteringClass = `is-entering-${direction}`;
    const leavingClass = `is-leaving-${direction}`;
    const transitionClasses = ["is-active", "is-entering-forward", "is-leaving-forward", "is-entering-backward", "is-leaving-backward"];
    clearTimeout(state.videoTransitionTimer);
    nextPlayer.classList.remove(...transitionClasses);
    nextPlayer.classList.add(enteringClass);
    loadPlayer(nextPlayer, artworks[nextIndex], true);
    videoLoader.classList.add("is-ready");
    oldPlayer.classList.remove(...transitionClasses);
    oldPlayer.classList.add(leavingClass);
    void nextPlayer.offsetWidth;
    window.requestAnimationFrame(() => {
      nextPlayer.classList.remove(enteringClass);
      nextPlayer.classList.add("is-active");
    });
    state.activePlayer = 1 - state.activePlayer;
    state.currentIndex = nextIndex;
    renderCurrent();
    const finishTransition = () => {
      if (!state.isTransitioning) return;
      oldPlayer.classList.remove(...transitionClasses);
      oldPlayer.pause();
      loadPlayer(oldPlayer, artworks[nextIndex + (direction === "forward" ? 1 : -1)]);
      state.isTransitioning = false;
    };
    nextPlayer.addEventListener("transitionend", finishTransition, { once: true });
    state.videoTransitionTimer = window.setTimeout(finishTransition, 520);
  }

  function selectRating(rating) {
    if (state.isTransitioning) return;
    const artworks = orderedArtworks();
    const artwork = artworks[state.currentIndex];
    state.ratings[artwork.slug] = rating;
    track("artwork_rating", { rd_vote_artwork: artwork.slug, rd_vote_rating: rating, rd_vote_position: state.currentIndex + 1 });
    renderCurrent();
    clearTimeout(state.transitionTimer);
    state.transitionTimer = window.setTimeout(() => {
      if (state.currentIndex === artworks.length - 1) {
        players.forEach((player) => player.pause());
        renderFinalists();
        setScreen(finalistScreen);
        track("final4_view");
        return;
      }
      transitionToIndex(state.currentIndex + 1);
    }, 360);
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }[character]));
  }

  function renderFinalists() {
    const orderIndex = new Map(state.orderSlugs.map((slug, index) => [slug, index]));
    const ranked = [...ARTWORKS].sort((a, b) => {
      return (Number(state.ratings[b.slug]) || 0) - (Number(state.ratings[a.slug]) || 0) || (orderIndex.get(a.slug) || 0) - (orderIndex.get(b.slug) || 0);
    });
    finalistGrid.innerHTML = ranked.map((artwork) => {
      const selected = state.finalists.includes(artwork.slug);
      const rating = Number(state.ratings[artwork.slug]) || 0;
      return `<button class="finalist-card${selected ? " is-selected" : ""}" type="button" data-finalist="${escapeHtml(artwork.slug)}" aria-pressed="${selected}">
        <img src="${escapeHtml(artwork.poster)}" alt="${escapeHtml(artwork.title)}" loading="lazy">
        <span class="finalist-card__check" aria-hidden="true">✓</span>
        <span class="finalist-card__copy"><strong>${escapeHtml(artwork.title)}</strong><small>คะแนนเดิม ${rating} / 5</small></span>
      </button>`;
    }).join("");
    updateFinalistStatus();
  }

  function updateFinalistStatus() {
    finalistStatus.textContent = `เลือกแล้ว ${state.finalists.length} / 4`;
    submitButton.disabled = state.finalists.length !== 4;
    persistState();
  }

  function formatExpiry(value) {
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) return "ใช้สิทธิ์ภายใน 48 ชั่วโมง";
    return `ใช้สิทธิ์ภายใน ${new Intl.DateTimeFormat("th-TH", { dateStyle: "medium", timeStyle: "short", timeZone: "Asia/Bangkok" }).format(date)} น.`;
  }

  function renderReward(reward, isTest = false) {
    state.reward = reward || null;
    rewardChoices.classList.add("is-hidden");
    rewardCodeRow.classList.add("is-hidden");
    rewardExpiry.classList.add("is-hidden");
    retryRewardButton.classList.add("is-hidden");
    rewardChoices.innerHTML = "";
    if (isTest) {
      rewardState.textContent = "โหมดทดสอบผ่าน: ข้อมูลครบ และยังไม่ได้บันทึกคะแนนหรือสร้างส่วนลดจริง";
      return;
    }
    if (!reward || reward.status !== "ready" || !Array.isArray(reward.checkout_links)) {
      rewardState.textContent = "บันทึกคำตอบแล้ว แต่ระบบสร้างสิทธิ์ยังไม่สำเร็จ กรุณากดลองอีกครั้ง";
      retryRewardButton.classList.remove("is-hidden");
      return;
    }
    rewardState.textContent = "สิทธิ์พร้อมแล้ว เลือกกลิ่นที่ต้องการ";
    rewardChoices.innerHTML = reward.checkout_links.map((item) => `<a class="reward-choice" href="${escapeHtml(item.url)}" data-reward-scent="${escapeHtml(item.scent)}"><span>${escapeHtml(item.scent)}</span><strong>ซื้อ 89 บาท →</strong></a>`).join("");
    rewardChoices.classList.remove("is-hidden");
    rewardCode.textContent = reward.code || "";
    rewardCodeRow.classList.remove("is-hidden");
    rewardExpiry.textContent = formatExpiry(reward.expires_at);
    rewardExpiry.classList.remove("is-hidden");
    persistState();
    track("reward_unlock", { rd_vote_reward_status: "ready" });
  }

  function buildPayload() {
    return {
      action: "vote_m10_submit",
      campaign,
      audience,
      submission_id: state.sessionId,
      scores: state.ratings,
      finalists: state.finalists,
      presentation_order: state.orderSlugs,
      duration_seconds: state.startedAt ? Math.round((Date.now() - state.startedAt) / 1000) : 0,
      source: "rudedog_shopify",
      test: qaMode,
    };
  }

  async function submitVote() {
    if (state.finalists.length !== 4 || Object.keys(state.ratings).length !== ARTWORKS.length) return;
    if (!endpoint) {
      showToast("ยังไม่ได้เชื่อมระบบรับคะแนน", 2600);
      return;
    }
    submitButton.disabled = true;
    submitButton.textContent = "กำลังส่งคำตอบ...";
    const payload = buildPayload();
    state.lastPayload = payload;
    track("submit_attempt");
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error("submit_http_error");
      const data = await response.json();
      if (!data || data.ok !== true) throw new Error(data && data.error ? data.error : "submit_failed");
      if (!qaMode) state.submitted = true;
      setScreen(completeScreen);
      renderReward(data.reward, data.test === true);
      persistState();
      track("submit_success", { rd_vote_duplicate: data.duplicate === true });
    } catch (error) {
      console.error("M10 vote submission failed", error);
      showToast("ส่งคำตอบไม่สำเร็จ กรุณาลองอีกครั้ง", 2600);
      submitButton.disabled = false;
      track("submit_error");
    } finally {
      submitButton.textContent = "ส่งคำตอบและรับสิทธิ์";
    }
  }

  startButton.addEventListener("click", () => {
    if (state.submitted && state.reward && !qaMode) {
      setScreen(completeScreen);
      renderReward(state.reward);
      return;
    }
    if (!state.startedAt) state.startedAt = Date.now();
    setScreen(voteScreen);
    preparePlayers();
    renderCurrent();
    track("start", { rd_vote_resumed: Object.keys(state.ratings).length > 0 });
  });

  exitButton.addEventListener("click", () => {
    players.forEach((player) => player.pause());
    setScreen(introScreen);
  });

  players.forEach((player) => player.addEventListener("canplay", () => videoLoader.classList.add("is-ready")));
  players.forEach((player) => player.addEventListener("error", () => videoLoader.classList.add("is-ready")));
  ratingButtons.forEach((button) => button.addEventListener("click", () => selectRating(Number(button.dataset.rating))));
  previousButton.addEventListener("click", () => { if (state.currentIndex > 0) transitionToIndex(state.currentIndex - 1); });
  backToRatingsButton.addEventListener("click", () => {
    state.currentIndex = orderedArtworks().length - 1;
    setScreen(voteScreen);
    preparePlayers();
    renderCurrent();
  });

  finalistGrid.addEventListener("click", (event) => {
    const card = event.target.closest("[data-finalist]");
    if (!card) return;
    const slug = card.dataset.finalist;
    const index = state.finalists.indexOf(slug);
    if (index >= 0) state.finalists.splice(index, 1);
    else if (state.finalists.length < 4) state.finalists.push(slug);
    else {
      showToast("เลือกได้สูงสุด 4 ลาย");
      return;
    }
    card.classList.toggle("is-selected", state.finalists.includes(slug));
    card.setAttribute("aria-pressed", String(state.finalists.includes(slug)));
    updateFinalistStatus();
    track("final4_change", { rd_vote_final4_count: state.finalists.length });
  });

  submitButton.addEventListener("click", submitVote);
  retryRewardButton.addEventListener("click", submitVote);
  rewardChoices.addEventListener("click", (event) => {
    const link = event.target.closest("[data-reward-scent]");
    if (link) track("reward_click", { rd_vote_reward_scent: link.dataset.rewardScent || "" });
  });

  function recoverActiveVideo() {
    if (voteScreen.classList.contains("is-hidden")) return;
    clearTimeout(state.videoTransitionTimer);
    state.isTransitioning = false;
    players.forEach((player, index) => {
      player.className = index === state.activePlayer ? "artwork-video is-active" : "artwork-video";
      if (index !== state.activePlayer) player.pause();
    });
    playPlayer(players[state.activePlayer]);
  }

  window.addEventListener("pageshow", recoverActiveVideo);
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) players.forEach((player) => player.pause());
    else recoverActiveVideo();
  });

  restoreState();
  updateAudienceCopy();
  track("landing");
})();
